/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { createTypedSessionStorage } from '@toss/storage/typed';

export enum HeaderMessageKey {
  ServerlessEndpointsTrial = 'serverless-endpoints-trial',
  ContainerTrial = 'container-trial',
}

export const isHeaderMessageClosedStorage = createTypedSessionStorage<Record<string, boolean>>(
  'is-header-message-closed',
  { initialValue: {} }
);

export function getIsHeaderMessageClosed(key: HeaderMessageKey) {
  const storage = isHeaderMessageClosedStorage.get();

  if (!storage) return false;

  return storage[key];
}

export function setIsHeaderMessageClosed(key: HeaderMessageKey, value: boolean) {
  const storage = isHeaderMessageClosedStorage.get();
  isHeaderMessageClosedStorage.set({ ...storage, [key]: value });
}
